import React, { ReactNode } from 'react'
import CarePlanSectionContent from '../../../../../../components/carePlans/CarePlanSectionContent'
import CarePlanSectionHeader from '../../../../../../components/carePlans/CarePlanSectionHeader'
import styles from '../../CarePlanReiviewForm.styles'
import { CarePlan } from '@lmc/ts-common'

interface ICarePlanReviewSection {
  title: string
  innerComponent?: ReactNode
  content?: string
  fields?: CarePlan
  FORM_ID?: string
}

export const CarePlanReviewSection = ({
  fields,
  title,
  content,
  FORM_ID,
  innerComponent = undefined,
}: ICarePlanReviewSection): React.ReactElement => (
  <div style={styles.sectionContainer}>
    <CarePlanSectionHeader title={title} />
    {innerComponent ? (
      <div style={styles.innerSectionContainer}>
        {innerComponent}
        <CarePlanSectionContent
          formId={FORM_ID}
          fields={fields}
          keys={title.toLowerCase()}
          value={content}
        />
      </div>
    ) : (
      <CarePlanSectionContent
        formId={FORM_ID}
        fields={fields}
        keys={title.toLowerCase()}
        value={content}
      />
    )}
  </div>
)

export default CarePlanReviewSection
